export const getSeverity = (params: {
  firstValue: number | null
  increaseIsPositive: boolean
  lastValue: number | null
}): 'error' | 'success' | null => {
  const { firstValue, increaseIsPositive, lastValue } = params

  if (firstValue === null || lastValue === null) return null

  const diff = lastValue - firstValue

  if (diff === 0) return null

  if (diff < 0) return increaseIsPositive ? 'error' : 'success'

  // diff > 0
  return increaseIsPositive ? 'success' : 'error'
}

export const getPercentageChange = (params: {
  firstValue: number | null
  lastValue: number | null
}) => {
  const { firstValue, lastValue } = params

  if (firstValue === null || lastValue === null) return null

  const diff = lastValue - firstValue

  if (firstValue === 0) {
    if (lastValue === 0) {
      return 0 // both zero → no change
    } else {
      // ∞ or -∞
      return lastValue > 0 ? Infinity : -Infinity
    }
  } else {
    return (diff / Math.abs(firstValue)) * 100
  }
}

export const getDiff = (params: {
  firstValue: number | null
  lastValue: number | null
}) => {
  const { firstValue, lastValue } = params

  if (firstValue === null || lastValue === null) return null

  return lastValue - firstValue
}
